function filterByIds(data = [], filterIds, key) {
  const filterArray = Array.isArray(filterIds) ? filterIds : [filterIds];
  if (!filterArray.length || filterArray.some((id) => id == null)) {
    return data || [];
  }
  return (data || [])?.filter(
    (item) =>
      Array.isArray(item[key]) &&
      item[key].some((id) => filterArray.includes(id))
  );
}

export default filterByIds;
